module.exports = __webpack_public_path__ + "img/customer-service-3.35cf4f00.jpg";